import { FC, useEffect } from 'react';

import ChallengesBanner from '@/components/EarnTon/Challenges/ChallengesBanner/ChallengesBanner.tsx';
import { useTonStore } from '@/store/useTonStore.ts';
import ListSkeleton from '@/components/EarnTon/ListSkeleton.tsx';
import { TonChallengeTypes } from '@/enums/apiEnums.ts';
import { TonChallenge } from '@/api/ton/types.ts';
import ChallengeItem from '@/components/EarnTon/Challenges/ChallengeItems/ChallengeItem.tsx';

const Challenges: FC = () => {
  const { challenges, fetchChallenges } = useTonStore();

  useEffect(() => {
    const getChallenges = async () => {
      if (challenges.data?.length === 0) await fetchChallenges();
    };

    void getChallenges();
  }, []);

  const renderChallengeItem = (challenge: TonChallenge, index: number) => {
    if (challenge.type === TonChallengeTypes.TYPE_UNSPECIFIED) return null;
    return <ChallengeItem key={index} challengeData={challenge} />;
  };

  return (
    <>
      <ChallengesBanner />
      <div
        style={{
          width: 'calc(100% - 40px)',
          marginTop: '10px',
          marginLeft: '5px',
          marginRight: '6px',
          maxHeight: 'calc(50% - 80 launchpx)',
          flex: 1,
          overflowY: 'auto',
          overscrollBehavior: 'none',
          flexDirection: 'column'
        }}
      >
        {challenges.data?.length > 0 ? (
          challenges.data.map((challenge, index) =>
            renderChallengeItem(challenge, index)
          )
        ) : (
          <ListSkeleton />
        )}
      </div>
    </>
  );
};

export default Challenges;
